import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FloatingWidget from '../components/FloatingWidget';
import BookingModal from '../components/BookingModal';
import { useData } from '../context/DataContext';

const MainLayout = ({ children }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { settings, loading } = useData();

    // Global loading screen removed to ensure Header and Logo appear instantly. 
    // Content-specific loading is handled within HomePage and other sections.

    return (
        <>
            <Header onOpenBooking={() => setIsModalOpen(true)} />
            <main>
                {children}
            </main>
            <Footer onOpenBooking={() => setIsModalOpen(true)} />
            <FloatingWidget onOpenBooking={() => setIsModalOpen(true)} />
            <BookingModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </>
    );
};

export default MainLayout;



